<template>
  <v-container fluid>
    <v-row>
      <v-col cols="1">
        <span>{{ $t('rtrck.title.crol') }}</span>
      </v-col>
      <v-col cols="3">
        <v-toolbar dense flat height="32px">
          <v-autocomplete name="crol" v-model="crol.crol" :items="crolList" @update:search-input="searchCrol" :label="$t('rtrck.ph.crol')" clearable dense flat hide-no-data hide-details solo> </v-autocomplete>
        </v-toolbar>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="1">
        <span>{{ $t('rtrck.title.registrant') }} / {{ $t('rtrck.title.regist.term') }}</span>
      </v-col>
      <v-col cols="3">
        <v-toolbar dense flat height="32px">
          <v-autocomplete name="registrant" v-model="crol.registrant" :items="registrantList" @update:search-input="searchRegistrant" :label="$t('rtrck.ph.user')" clearable dense flat hide-no-data hide-details solo> </v-autocomplete>
        </v-toolbar>
      </v-col>
      <v-col cols="3">
        <v-toolbar dense flat height="32px">
          <div>
            <date-time-range-picker-neo v-model="crol.regTerm" :clearable="true" @click:clear="clearRegTerm"></date-time-range-picker-neo>
          </div>
        </v-toolbar>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="1">
        <span>{{ $t('rtrck.title.updated.by') }} / {{ $t('rtrck.title.upd.term') }}</span>
      </v-col>
      <v-col cols="3">
        <v-toolbar dense flat height="32px">
          <v-autocomplete name="updater" v-model="crol.updater" :items="updaterList" @update:search-input="searchUpdater" :label="$t('rtrck.ph.user')" clearable dense flat hide-no-data hide-details solo> </v-autocomplete>
        </v-toolbar>
      </v-col>
      <v-col cols="3">
        <v-toolbar dense flat height="32px">
          <div>
            <date-time-range-picker-neo v-model="crol.updTerm" :clearable="true" @click:clear="clearUpdTerm"></date-time-range-picker-neo>
          </div>
        </v-toolbar>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { isEmpty } from 'lodash';
import { api } from '@/api/common/instances';
export default {
  props: {
    params: {
      type: Object,
    },
  },
  data() {
    return {
      crolList: [],
      registrantList: [],
      updaterList: [],
    };
  },
  computed: {
    ...mapState('extra/auth/role-tracker', ['crol', 'initFilter']),
  },
  watch: {
    'crol.crol': {
      handler() {
        this.crolList = (() => {
          if (this.crol.crol === undefined) return [];
          else return [this.crol.crol];
        })();
      },
    },
    'crol.registrant': {
      handler() {
        this.registrantList = (() => {
          if (this.crol.registrant === undefined) return [];
          else return [this.crol.registrant];
        })();
      },
    },
    'crol.updater': {
      handler() {
        this.updaterList = (() => {
          if (this.crol.updater === undefined) return [];
          else return [this.crol.updater];
        })();
      },
    },
  },
  methods: {
    ...mapActions('extra/auth/role-tracker', ['setCrol']),
    async searchCrol(input) {
      if (input === null || input == this.crol.crol) return;
      this.crolList = await this.autoSearch('crol', { agrName: input });
      this.crolList.unshift(isEmpty(input) ? input : input.toUpperCase());
    },
    async searchRegistrant(input) {
      if (input === null || input == this.crol.registrant) return;
      this.registrantList = await this.autoSearch('user', { bname: input });
      this.registrantList.unshift(isEmpty(input) ? input : input.toUpperCase());
    },
    async searchUpdater(input) {
      if (input === null || input == this.crol.updater) return;
      this.updaterList = await this.autoSearch('user', { bname: input });
      this.updaterList.unshift(isEmpty(input) ? input : input.toUpperCase());
    },
    async autoSearch(uri, params) {
      const {
        data: { items },
      } = await api.get(`/rtrck/search/auto-search/${uri}`, {
        params: {
          ...this.params,
          ...params,
        },
      });
      return items;
    },
    clearRegTerm() {
      let c = {
        ...this.crol,
      };
      c.regTerm = this.initFilter.crol.regTerm;
      this.setCrol(c);
    },
    clearUpdTerm() {
      let c = {
        ...this.crol,
      };
      c.updTerm = this.initFilter.crol.updTerm;
      this.setCrol(c);
    },
  },
};
</script>

<style scoped>
.row-h-34 {
  height: 34px;
}
.col-1 {
  padding-top: 10px;
}
.datepick-width {
  width: 190px;
}
.v-toolbar ::v-deep .v-toolbar__content {
  padding: 4px;
}
</style>
